import { RefundContainer, RefundContent, Title } from '../Refund/styled';

export default function index() {
  return (
    <RefundContainer>
      <Title>Cancellation</Title>
      <RefundContent>
        Cancellation of orders can only be made at any time before you receive
        an intimation containing confirmation of your order. No cancellations
        will be accepted post such time and for any cancellation request
        received post such time, you will need to raise a return request after
        the order has been delivered.
      </RefundContent>
    </RefundContainer>
  );
}
